import { subscriptionPlanAdminClient } from '@/helpers/api/apiClients'
import {
	SearchSubscriptionPlansRequest,
	type ISearchSubscriptionPlansRequest,
	CreateSubscriptionPlanAdminRequest,
	type ICreateSubscriptionPlanAdminRequest,
	SubscriptionPlanPaymentCycleTypes,
	UpdateSubscriptionPlanAdminRequest,
	type IUpdateSubscriptionPlanAdminRequest,
	SubscriptionPlanFeatureItemRequest,
	SubscriptionPackItemRequest,
} from '@/helpers/api/WebApiClient'

interface FeatureItemInput {
	id?: number
	featureText: string
	sortOrder: number
}

const toFeatureInstances = (features?: FeatureItemInput[]) => features?.map((f) => new SubscriptionPlanFeatureItemRequest(f))
const toPackInstances = (packs?: PackItemInput[]) => packs?.map((p) => new SubscriptionPackItemRequest(p))

interface PackItemInput {
	id?: number
	name: string
	userCount: number
	userPrice: number
	instanceCount: number
	instancePrice: number
	databaseCount: number
	databasePrice: number
	isActive: boolean
	displayOrder: number
}

type CreatePlanInput = Omit<ICreateSubscriptionPlanAdminRequest, 'features' | 'packs'> & { features?: FeatureItemInput[]; packs?: PackItemInput[] }
type UpdatePlanInput = Omit<IUpdateSubscriptionPlanAdminRequest, 'features' | 'packs'> & { features?: FeatureItemInput[]; packs?: PackItemInput[] }

export const subscriptionPlanAdminService = {
	search: (request: ISearchSubscriptionPlansRequest) =>
		subscriptionPlanAdminClient.search(new SearchSubscriptionPlansRequest(request)),

	getById: (id: number) =>
		subscriptionPlanAdminClient.getById(id),

	create: (request: CreatePlanInput) =>
		subscriptionPlanAdminClient.create(
			new CreateSubscriptionPlanAdminRequest({
				...request,
				subscriptionPlanPaymentCycleType: SubscriptionPlanPaymentCycleTypes.OneTime,
				features: toFeatureInstances(request.features),
				packs: toPackInstances(request.packs),
			})
		),

	update: (request: UpdatePlanInput) => {
		const updateRequest = new UpdateSubscriptionPlanAdminRequest({
			...request,
			subscriptionPlanPaymentCycleType: SubscriptionPlanPaymentCycleTypes.OneTime,
			features: toFeatureInstances(request.features),
			packs: toPackInstances(request.packs),
		})
		updateRequest.id = request.id

		return subscriptionPlanAdminClient.update(updateRequest)
	},

	delete: (id: number) =>
		subscriptionPlanAdminClient.delete(id),

	activate: (id: number) =>
		subscriptionPlanAdminClient.activate(id),

	deactivate: (id: number) =>
		subscriptionPlanAdminClient.deactivate(id),
}
